import {
  createAuthMiddleware,
  AuthEvents,

} from './common/auth/index';

import rootReducer from './common/reducers/index';
import appconfig from './config/oAuthConfig';


import {
  createStore,
  applyMiddleware,
  compose
} from 'redux';

import thunk from 'redux-thunk';

const authEvents = new AuthEvents();

const initialState = {};
const enhancers = [];
const env_name =(typeof process.env.REACT_APP_DATALOADER_APP_ENV  !== "undefined" )  ? process.env.REACT_APP_DATALOADER_APP_ENV : 'local'
let stageName= env_name==="prod"?"prod":"preprod"
const middleware = [thunk,createAuthMiddleware({ authEvents, config: appconfig.oAuth[stageName] })];

if (process.env.NODE_ENV === "development") {
  const devToolExtension = window.__REDUX_DEVTOOLS_EXTENSION__;

  if (typeof devToolExtension === "function") {
      enhancers.push(devToolExtension());
  }
}

const composedEnhancers = compose(
  applyMiddleware(...middleware),
  ...enhancers
);
const store = createStore(rootReducer, initialState, composedEnhancers);
export default store;

